export default {
explore_by: "Rechercher par",
explore_by_concepts: "Idées",
explore_by_families: "Familles olfactives",
language: "langue",
legal: "juridique/mentions légales",
find_any_fragrance: "trouver n'importe quel parfum dans le monde.",
title_by_concepts: "rechercher par idées",
desc_by_concepts: "trouver votre parfum en pensant à votre couleur ou endroit préféré",
title_by_families: "rechercher par familles olfactives",
desc_by_families: "trouver votre parfum en pensant ...",
expert_reviewed: "vérifié par un expert",
ingredients: "ingrédients",
description: "description",
perfumist: "parfumeur",
concepts: "concepts",
olfactive_family: "famille olfactive",
main_family: "famille",
sub_family: "sous-famille",
me_family: "Fragrances of the World",
filter_by_family: "familles",
filter_by_brand: "marques",
filter_by_gender: "genre",
for_him: "Pour lui",
for_her: "Pour elle",
unisex: "Unisex",
all: "Tous",
all_female: "Toutes",
concepts_list: "Liste des concepts",
no_results_for_this_combination: "Il n'y a pas de parfums pour cette combinaison",
select_at_least_one_concept: "Sélectionnez au moins un concept",
view_perfumes: "voir les parfums",
back: "Retourner",
close: "Fermer",
filters: "Filtres",
selected_concepts: "Concepts sélectionnés:",
selected_families: "Familles sélectionnées:",
find_concept: "Rechercher concepts...",
smell_of: "Odeur de",
touch_of: "Avec une touche de",
loading_perfumes: "chargement de parfums",
loading_concepts: "chargement de concepts",
apply: "appliquer",
search: "rechercher",
clear_all: "tout effacer",
iconic_fragrances: "Parfums iconiques de cette famille",
is_there_anybody_here: "",
continue_previous_session: "",
reset_session: "",
ingredient_type: "Type",
ingredient_parts: "Parties utilisées",
ingredient_extraction: "Méthode d'extraction",
ingredient_first: "Parfum iconique",
history: "Histoire",
effect: "Production et effet",
origin: "Origine",
iconic_fragrance: "Parfum iconique de cet ingrédient",
production: "Production",
loyalty_become_a_member: "Rejoignez le club",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"
}